import { type FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { CaseContact, VehicleDetails } from "@recobra/schemas/case";

import { TruncatedText } from "../lib";
import { formatPersonName } from "./format-name";

export const CaseDriverVehicleCell: FC<{
  vehicle?: VehicleDetails | null;
  driver?: Pick<CaseContact, "name"> | null;
  additionalVehicleCount?: number;
}> = ({ vehicle, driver, additionalVehicleCount = 0 }) => {
  const hasVehicleData = !!(vehicle?.licensePlate || vehicle?.make || vehicle?.model);
  const hasDriverData = !!driver?.name;

  if (!hasVehicleData && !hasDriverData) {
    return <span className="text-muted-foreground">{m.common_em_dash()}</span>;
  }

  const licensePlate = vehicle?.licensePlate ?? m.common_em_dash();
  const vehicleDesc = vehicle ? [vehicle.make, vehicle.model].filter(Boolean).join(" ") : "";
  const driverName = driver?.name ? formatPersonName(driver.name) : m.common_em_dash();

  return (
    <div className="min-w-0 flex flex-col gap-0.5">
      {hasVehicleData && (
        <div className="flex items-baseline gap-1.5 min-w-0">
          <span className="shrink-0 font-mono text-xs text-foreground">{licensePlate}</span>
          {vehicleDesc && <TruncatedText text={vehicleDesc} className="text-xs text-foreground" />}
          {additionalVehicleCount > 0 ? (
            <span className="shrink-0 text-xs text-muted-foreground">
              {m.case_additional_vehicles_count({ count: additionalVehicleCount })}
            </span>
          ) : null}
        </div>
      )}
      {hasDriverData && <TruncatedText text={driverName} className="text-xs text-foreground" />}
    </div>
  );
};
